import { Delete, Get, Post, Put } from "../index";

export const createEnquiryAPI = async (payload: any) => {
  // console.log(payload, "payload>>>>>");
  return Post({ url: `v1/enquiry/create`, payload });
};

export const getAllEnquiryAPI = async (
  payload?: { index: number; limit: number },
  searchValue?: string,
  filters?: {
    companyName?: string;
    eventType?: any;
    eventDate?: any;
    datePreference?: string;
    budgetFrom?: number;
    budgetTo?: number;
    status: string;
  }
) => {
  let url = `v1/enquiry/client-list`;

  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }

  // if (filters?.companyName) {
  //   url += `?companyName=${encodeURIComponent(filters.companyName)}`;
  // }
  // if (filters?.eventType) {
  //   url += `?eventType=${encodeURIComponent(filters.eventType)}`;
  // }
  // if (filters?.eventDate) {
  //   url += `?eventDate=${encodeURIComponent(filters.eventDate)}`;
  // }

  // if (filters?.datePreference) {
  //   url += `?datePreference=${encodeURIComponent(filters.datePreference)}`;
  // }
  // if (filters?.budget) {
  //   url += `?budget=${encodeURIComponent(filters.budget)}`;
  // }
  // if (filters?.status) {
  //   url += `?status=${encodeURIComponent(filters.status)}`;
  // }

  const body = {
    ...payload,
    companyName: filters?.companyName,
    eventType: filters?.eventType,
    eventDate: filters?.eventDate,
    datePreference: filters?.datePreference,
    budgetFrom: filters?.budgetFrom,
    budgetTo: filters?.budgetTo,
    status: filters?.status,
  };

  return Post({ url, payload: body });
};
export const getAllEnquiryListAPI = async (
  payload?: { index: number; limit: number },
  // searchValue?: string,
  filters?: {
    companyName?: string;
    eventType?: any;
    eventDate?: any;
    datePreference?: string;
    budgetFrom?: number;
    budgetTo?: number;
    status: string;
  }
) => {
  let url = `v1/enquiry/clientlist`;

  // if (searchValue) {
  //   url += `?search=${encodeURIComponent(searchValue)}`;
  // }

  const body = {
    ...payload,
    companyId: filters?.companyName,
    eventType: filters?.eventType,
    eventDate: filters?.eventDate,
    datePreference: filters?.datePreference,
    budgetFrom: filters?.budgetFrom,
    budgetTo: filters?.budgetTo,
    status: filters?.status,
  };

  return Post({ url, payload: body });
};

export const getCustomerByIDAPI = async (id: any) => {
  // console.log(id,"id>>>>");
  return Get({ url: `v1/customer/${id}` });
};
export const getemployeeByIDAPI = async (id: any) => {
  return Get({ url: `v1/employee/${id}` });
};
// Get All Sales Manager
export const getAllSalesManager = async () => {
  return Get({ url: `v1/enquiry/sales-managers` });
};

export const getAllCompanyAPI = async () => {
  return Get({ url: `v1/company` });
};
export const getCompanyByIDAPI = async (id:any) => {
  return Get({ url: `v1/company/${id}` });
};

export const createCompanyAPI = async (payload: any) => {
  // console.log(payload, "payload>>>>>");
  return Post({ url: `v1/company/create`, payload });
};

export const getAllAssociatedEventAPI = async (customerID: any) => {
  // console.log(customerID, "customerID>>>>");
  return Get({ url: `v1/enquiry/customer-events/${customerID}` });
};
export const updateAssignedToCompanyAPI = async (
  customerId: any,
  payload: any
) => {
  // console.log(customerId, "customerId>>>>", payload, "CompanyId");
  return Put({ url: `v1/customer/update/${customerId}`, payload });
};
export const createCustomerAPI = async (payload: any) => {
  // console.log(payload, "payload>>>>>");
  return Post({ url: `v1/customer/create`, payload });
};

export const getAllCustomerAPI = async (
  payload?: { index: number; limit: number },
  searchValue?: string
) => {
  let url = `v1/customer`;

  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }
  return Post({ url, payload: payload });
};
export const getAllCustomerByCompanyAPI = async (
  payload?: { index: number; limit: number },
  searchValue?: string,
  companyID?: any
) => {
  let url = `v1/customer/customerByCompany/${companyID}`;

  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }
  return Post({ url, payload: payload });
};


  export const updateCustomerAPI = async (customerId:any,payload:any) => {
    // console.log(customerId,"customerId>>>>",payload,"CompanyId");
    return Put({ url: `v1/customer/update/${customerId}`,payload})
  }
  
  export const createRequirementAPI = async (payload: any) => {
    // console.log(payload,"payload>>>>>");
    return Post({ url: `v1/customerRequirement/create`, payload })
  }
  export const updateInitalRequirementAPI = async (RequirementId:any,payload:any) => {
    // console.log(RequirementId,"customerId>>>>",payload,"CompanyId");
    return Put({ url: `v1/customerRequirement/updateinitialAddRequirements/${RequirementId}`,payload})
  }
  export const updateRequirementAPI = async (RequirementId:any,payload:any) => {
    // console.log(RequirementId,"customerId>>>>",payload,"CompanyId");
    return Put({ url: `v1/customerRequirement/update/${RequirementId}`},payload)
  }
  export const editRequirementByIdAPI = async (RequirementId:any,payload:any) => {
    // console.log(RequirementId,"customerId>>>>",payload,"CompanyId");
    return Put({ url: `v1/customerRequirement/updateSubRequirement/${RequirementId}`,payload})
  }

  export const deleteRequirementByIdAPI = async (RequirementId:any) => {
    // console.log(RequirementId,"customerId>>>>");
    return Delete({ url: `v1/customerRequirement/deleteSubRequirement/${RequirementId}`})
  }

  export const getRequirementByIDAPI = async (RequirementId:any) => {
    return Post({ url: `v1/customerRequirement/view/${RequirementId}`})
  }

  export const getAllRequirementAPI = async () => {
    return Post({ url: `v1/customerRequirement/getAll`})
  }

  export const getAllProposalByIDAPI = async (eventId:any,payload?: { index: number; limit: number; }) => {
    // console.log(eventId,"eventId>>>>>");
    return Post({ url: `v1/proposal/event/${eventId}`,payload})
  }

  export const getEventByIDAPI = async (eventId:any) => {
    // console.log(eventId,"eventId>>>>>");
    return Get({ url: `v1/event/view/${eventId}`})
  }
  export const getSelectedEventByVenueAPI = async (eventId:any,payload:any) => {
    // console.log(eventId,"eventId>>>>>");
    return Post({ url: `v1/event/viewVenues/${eventId}`,payload})
  }
  export const getSelectedEventBySupplierAPI = async (eventId:any,payload:any) => {
    // console.log(eventId,"eventId>>>>>");
    return Post({ url: `v1/event/viewSuppliers/${eventId}`,payload})
  }
  export const sendProposalMailAPI = async (payload:any) => {
    // console.log(payload,"payload>>>>>");
    return Post({ url: `v1/proposal/send-proposal-mail`,payload},"multipart/form-data")
  }
  export const sendProposalMailTrackingAPI = async (eventId:any,payload:any) => {
    // console.log(payload,"payload>>>>>",eventId,"eventId>>>>");
    return Put({ url: `v1/event/mailtracking/${eventId}`,payload})
  }
  export const getProposalMailTrackingAPI = async (eventId:any) => {
    // console.log(eventId,"eventId>>>>");
    return Get({ url: `v1/event/viewMailtracking/${eventId}`,})
  }
  export const updateEventAPI = async (eventId:any,payload:any) => {
    // console.log(payload,"payload>>>>>",eventId,"eventId>>>>");
    return Put({ url: `v1/enquiry/update-event/${eventId}`,payload})
  }
  
//TIMING SERVICES
export const postTiming = async (payload: any,) => {
  return Post({ url: `v1/timing/create`, payload });
};

export const getAllTime = async (eventId:string) => {
  return Get({ url: `v1/timing/timingsByEvent/${eventId}` });
};

export const deleteParticularEvent = async (timingId:string,detailsId:string) => {
  return Delete({ url: `/v1/timing/delete/${timingId}/time/${detailsId}` });
};

export const editEvent = async (eventId:string,payload:any) => {
  return Put({ url: `/v1/timing/update/${eventId}`,payload });
};

export const deleteEntireTimeComponent=async(detailId:string,eventId:string)=>{
  return Delete({ url: `/v1/timing/delete/${detailId}/event/${eventId}` });
}

export const updateEntireTime=async(timingId:string,payload:any)=>{
  return Put({ url: `/v1/timing/update/${timingId}`,payload});
}
export const updateVenueShortlistStatus=async(eventId:string,payload:any)=>{
  return Put({ url: `/v1/shortlist/venue/${eventId}`,payload});
}
export const updateSupplierShortlistStatus=async(eventId:string,payload:any)=>{
  return Put({ url: `/v1/shortlist/supplier/${eventId}`,payload});
}

export const getAllShorlisted = async (eventId:string) => {
  return Get({ url: `v1/shortlist/list/${eventId}` });
};
export const getViewVenueShorlistedAPI = async (eventId:string,payload:any) => {
  return Post({ url: `v1/event/viewShortlistedVenues/${eventId}`,payload});
};
export const getViewSupplierShorlistedAPI = async (eventId:string,payload:any) => {
  return Post({ url: `v1/event/viewShortlistedSuppliers/${eventId}`,payload});
};

export const uploadClientTemplateAPI = async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/eventTemplate/create`,payload},"multipart/form-data")
}
export const getUploadClientTemplateAPI = async (eventId:any) => {
  // console.log(eventId,"eventId>>>>>");
  return Get({ url: `v1/eventTemplate/viewEventTeamplate/${eventId}`})
}


//API FOR ASSIGN PLANNER TO EVENT
export const updatePlannerToEvent=async(eventID:string,payload:any)=>{
  return Put({url:`v1/enquiry/assign-planner-to-event/${eventID}`,payload})
}

//API FOR ASSIGN SALES TO EVENT
export const updateSalesToEvent=async(eventID:string,payload:any)=>{
  return Put({url:`v1/enquiry/assign-sales-to-event/${eventID}`,payload})
}

export const getAllSuggestedSupplierAPI = async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/supplier/getAllSuggestedSupplierDetails`,payload})
}

export const getAllSuggestedVenueAPI = async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/venue/getAllSuggestedVenueDetails`,payload})
}

export const createCompanyEmployeeAPI = async (payload: any) => {
  // console.log(payload, "payload>>>>>");
  return Post({ url: `v1/employee/create`, payload });
};

export const updateEmployeeByCompanyAPI=async(EmployeeID:string,payload:any)=>{
  return Put({url:`v1/employee/${EmployeeID}`,payload})
}

export const getAllEmployeeByCompanyAPI = async (
  payload?: { index: number; limit: number },
  searchValue?: string,
  companyID?: any,
  EventID?:any
) => {
  let url = `/v1/employee/by-company-event/${companyID}/event/${EventID}`;

  if (searchValue) {
    url += `?search=${encodeURIComponent(searchValue)}`;
  }
  return Post({ url, payload: payload });
};

export const getAllB2BEmployeeAPI = async (eventId:any) => {
  console.log(eventId,"eventId>>>>>");
  return Get({ url: `v1/employee/b2b/${eventId}`})
}


export const getAllB2CEmployeeAPI = async (
  payload?: { index: number; limit: number,searchValue?: string },
  
) => {
  let url = `/v1/employee/getAllEmployees`;

  // if (searchValue) {
  //   url += `?search=${encodeURIComponent(searchValue)}`;
  // }
  return Post({ url, payload: payload });
};

export const createProposalAPI= async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/proposal/create`,payload})
}

export const getProposalByIdAPI = async (proposalId:any) => {
  // console.log(proposalId,"proposalId>>>>>");
  return Get({ url: `v1/proposal/${proposalId}`})
}

export const updateProposalStatusAPI=async(proposalId:string,payload:any)=>{
  return Put({url:`v1/proposal/status/${proposalId}`,payload})
}

export const updateProposalAPI=async(proposalId:string,payload:any)=>{
  return Put({url:`v1/update/${proposalId}`,payload})
}

// Pricing API

export const createPricingAPI= async (payload:any) => {
  // console.log(payload,"payload>>>>>");
  return Post({ url: `v1/eventBill/create`,payload})
}

export const updatePricingAPI=async(priceID:string,payload:any)=>{
  return Put({url:`v1/eventBill/update/${priceID}`,payload})
}

export const getPricingByIdAPI = async (priceID:any,eventID:any) => {
  // console.log(priceID,"priceID>>>>>",eventID,"eventID>>>>");
  return Get({ url: `v1/eventBill/view/${priceID ? priceID : "_id"}?eventId=${eventID}`})
}

export const deletePricingByIdAPI = async (priceID:string) => {
  return Delete({ url: `v1/eventBill/delete/${priceID}` });
};

export const updateEnquiryAPI=async(eventId:string,payload:any)=>{
  return Put({url:`v1/event/update/${eventId}`,payload})
}

export const updateSuggestedVenuesAPI=async(eventId:string,payload:any)=>{
  return Put({url:`v1/event/deleteSuggestedVenues/${eventId}`,payload})
}

export const updateSuggestedSuppliersAPI=async(eventId:string,payload:any)=>{
  return Put({url:`v1/event/deleteSuggestedSuppliers/${eventId}`,payload})
}

export const eventStatusUpdateAPI=async(eventId:string,payload:any)=>{
  return Put({url:`v1/event/eventStatusUpdate/${eventId}`,payload})
}


  

  




  

  
  


  
